import React, { useState } from 'react';
import { PhoneIcon, MessageCircleIcon, XIcon } from 'lucide-react';
export function StickyContact() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-tlfc-border shadow-lg lg:hidden animate-slide-up" data-id="element-485">
      <div className="flex items-center justify-between px-4 py-3" data-id="element-486">
        <div className="flex items-center gap-3" data-id="element-487">
          <a href="tel:0386009333" className="flex items-center gap-2 px-4 py-2.5 bg-tlfc-cream border border-tlfc-border rounded-lg text-sm font-medium text-tlfc-text" data-id="element-488">
            <PhoneIcon className="w-4 h-4 text-tlfc-gold" aria-hidden="true" data-id="element-489" />
            Call Now
          </a>
          <a href="#contact" className="flex items-center gap-2 px-4 py-2.5 bg-tlfc-gold text-white rounded-lg text-sm font-medium" data-id="element-490">
            <MessageCircleIcon className="w-4 h-4" aria-hidden="true" data-id="element-491" />
            Get in Touch
          </a>
        </div>
        <button onClick={() => setIsVisible(false)} className="p-2 text-tlfc-muted hover:text-tlfc-text transition-colors" aria-label="Close contact bar" data-id="element-492">
          <XIcon className="w-5 h-5" aria-hidden="true" data-id="element-493" />
        </button>
      </div>
    </div>;
}